/**
 * usePosture -- the bank's headline figures, computed once
 * (`GET /v1/posture`, stitching review 5.4).
 *
 * Any signed-in person may read it, so a seat that cannot open the board
 * still reads the board's figures rather than a fallback with no
 * denominator. Every surface that prints a headline count reads it here.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { api, type ApiError } from "shared/api/client";
import { postureKeys } from "shared/api/queryClient";
import type { Posture } from "shared/api/types";

export function usePosture(
  opts: { as_of?: string | undefined; enabled?: boolean } = {},
): UseQueryResult<Posture, ApiError> {
  const path = opts.as_of
    ? `/v1/posture?as_of=${encodeURIComponent(opts.as_of)}`
    : "/v1/posture";
  return useQuery({
    queryKey: postureKeys.at(opts.as_of),
    queryFn: () => api.get<Posture>(path),
    staleTime: 15_000,
    retry: false,
    enabled: opts.enabled ?? true,
  });
}
